import React from 'react';
import { FormattedMessage, FormattedNumber, FormattedPlural } from 'react-intl';
import styled from 'styled-components';

import { IconExternalLink } from '@xingternal/icons';
import { spaceS, xdlColorTextSecondary } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

const KununuReviewsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconExternalLinkStyled = styled(IconExternalLink)`
  color: ${xdlColorTextSecondary};
  margin-left: ${spaceS};
`;

type Props = {
  ratingCount: number;
  className?: string;
};

export const KununuReviews: React.FC<Props> = ({ ratingCount, className }) => (
  <KununuReviewsWrapper className={className}>
    <Meta size="small" data-testid="kununu-count" noMargin>
      <FormattedPlural
        value={ratingCount}
        one={
          <FormattedMessage id="JOBS_DETAIL_EMPLOYEE_REVIEW" values={{ ratingCount: <strong>{ratingCount}</strong> }} />
        }
        other={
          <FormattedMessage
            id="JOBS_DETAIL_EMPLOYEE_REVIEWS"
            values={{
              ratingCount: (
                <strong>
                  <FormattedNumber value={ratingCount} />
                </strong>
              ),
            }}
          />
        }
      />
    </Meta>
    <IconExternalLinkStyled data-testid="kununu-arrow-mobile" height={18} />
  </KununuReviewsWrapper>
);
